import { styled } from '../../utils/styled';
import { Drawer as DrawerUI } from '../Drawer';
import { closedMixin, drawerWidth, openedMixin } from './styles';

export const SideNavbarWrapper = styled('div')`
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: ${({ theme }) => theme.palette.background.dark};
  padding: ${({ theme }) => theme.spacing(3, 2)};
`;

export const MobileDrawer = styled(DrawerUI)({
  whiteSpace: 'nowrap',
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    borderRight: 'none',
    overflowX: 'hidden',
  },
});

export const Drawer = styled(DrawerUI)(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',

  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));
